import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import { AiFillEdit } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import deleteItem from '../../../../API/Client/DeleteClientType.js'
import { Button, Row, Col, Form } from 'react-bootstrap'
import CreateItem from './CreateTipKlijenta.js'
import UpdateItem from './UpdateTipKlijenta.js'
import { withNamespaces } from 'react-i18next';
import Select from 'react-select'
import GetCountries from './../../../../API/Client/GetCountries'
import GetClientTypes from './../../../../API/Client/GetClientTypes'
import { v4 as uuidv4 } from 'uuid';
import CreateButton from './../../../../Global/CreateButton'
import history from '../../../../history.js';

class TipoviKlijenata extends React.Component {
    constructor(props) {
        super(props)
    
        this.state={            
            loading: true,
            create: false,
            showDeleteModal: false,     
            uuidForDelete: "",  
            showOneItem: false,
            premesisList: [],
            countries: [],
            country: {},
            
            customStyles: {
                content : {
                    top                   : '50%',
                    left                  : '50%',
                    right                 : 'auto',
                    bottom                : 'auto',
                    transform             : 'translate(-50%, -50%)',
                    color: 'red'
                }
            },

              
            
        }
    }

    componentDidMount = async () => {
        this.setState({loading: true})  
        await this.setState({
            countries: [],
            country: {}
        })
        //get countries
        let items = await GetCountries()       
        let countryList = []
        
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })        

        if(this.props.searchClientType.countryUuid !== undefined && this.props.searchClientType.countryUuid.length > 0){            
            let data = countryList.filter((data) => data.value === this.props.searchClientType.countryUuid)
            .map((data) => {return data})

            await this.props.mapState("CHANGE_SEARCH_CLIENT_TYPE_PARAMETERS", data[0])
            await this.setState({
                countries: countryList,
                country: data[0]
            })
            this.search()
        }
        else if(countryList.length !== 0){
            await this.props.mapState("CHANGE_SEARCH_CLIENT_TYPE_PARAMETERS", countryList[0])
            await this.setState({
                countries: countryList,
                country: countryList[0]
            })
            this.search()
        }else{
            await this.props.mapState("CHANGE_SEARCH_CLIENT_TYPE_PARAMETERS", {})
            await this.setState({
                countries: [],
                country: {}
            })            
        }      

        this.setState({
            loading: false
        })
        
    }

    search = async () => {
        await this.setState({ loading: true})

        let lista = await GetClientTypes(this.props.searchClientType.countryUuid)

        if(lista.data.length > 0){
            
            this.props.mapState("MAP_CLIENT_TYPE_LIST", lista.data)
        }
        else{
            this.props.mapState("MAP_CLIENT_TYPE_LIST", [])
        }

        await this.setState({ loading: false })
    }

    handleCountryChange = async (e) => {  
        await this.setState({
            country: e
        })     
        
        await this.props.mapState("CHANGE_SEARCH_CLIENT_TYPE_PARAMETERS", e)
        await this.search()      
    }

    handleChange(e){      
        this.setState({
            [e.target.id]: e.target.value
        })        
    }

    toggleCreate = async () => {
        await this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    backFromEdit(){
        if(this.state.country.value){
            this.search()
        }

        this.setState({
            showOneItem: !this.state.showOneItem
        })

        this.componentDidMount()
       
    }

    showDeleteModal = (uuid, country_uuid) => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid,
            country_uuid: country_uuid
        });
    };

    confirmDelete = async () => {
        
        let deleted = await deleteItem(this.state.country_uuid, this.state.uuidForDelete)
        if(deleted.status === 200){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('There was an error deleting your Client type, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })

            await store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t('The client type was deleted'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("MAP_ONE_CLIENT_TYPE", data)
        await this.setState({
            showOneItem: !this.state.showOneItem
        })
    }

    goBack(){
        history.goBack();
    }

   
    render(){
        const { loading, create, showOneItem } = this.state 
        const { t } = this.props

        const columns = [{
            dataField: 'client_type',
            text: t('Name'),
            headerStyle: {wordWrap: "break-word"},  
        }, {
            dataField: 'country',
            text: t('Country'),
            headerStyle: {wordWrap: "break-word"}, 
        } ,{
            dataField: 'pregled',
            isDummyField: true,
            text: '',
            style: {  width: '11.8em' },
            formatter: (cellContent, row) => {          
            return (
                <div key={uuidv4()}>
                    <Button 
                        variant='success'
                        className="btnDetalji me-2" 
                        onClick={() =>this.seeDetails(row)}
                    > 
                        <AiFillEdit /> {t('Details')} 
                    </Button> 

                    <Button
                        variant='danger'
                        className="btnIzbrisi"
                        onClick={() => this.showDeleteModal(row.uuid, row.country_uuid)}
                    >
                        <RiDeleteBin5Line /> {t('Delete')}
                    </Button> 
                </div> 
            );
            }
        }
    ]   
        

    return (
        loading ? 
            <Loader />
        :
            showOneItem? 
                <UpdateItem goBack={() => this.backFromEdit()} />
            :
            create ? 
                <CreateItem goBack={() => this.backFromCreate()} />
            :
                <>
                    <Row>
                        <Col sm={12} xl={12} md={12} >
                            <Form.Group as={Row}>
                                <Col sm={12} xl={2} className="p-4">
                                    {this.state.countries.length > 0 ?
                                        <Select
                                            options={this.state.countries}
                                            onChange={(values) => this.handleCountryChange(values)}
                                            isInvalid={this.state.country === null}
                                            value={this.state.country}
                                            maxMenuHeight={200}
                                        />
                                    : null}
                                </Col>
                                <Col sm={6} xl={6} className="p-4" />  

                                <Col sm={6} xl={4}>
                                    <CreateButton className="col-6 col-xl-4 p-4" toggleCreate={this.toggleCreate}/>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
            
                    {this.props.clientTypeList.length > 0 ?                       
                        <BootstrapTable
                            keyField="uuid" 
                            data={ this.props.clientTypeList } 
                            columns={ columns }                           
                            bodyStyle={{wordBreak: 'break-word'} }   
                            hover                 
                        />
                    :             
                        <div className="list-empty-container">
                            <h3>{this.state.countries.length > 0 ? t('List is empty') : t('Please add Country first')}</h3>
                        </div>
                 
                    }   
            
                    <Modal
                        isOpen={this.state.showDeleteModal}                
                        onRequestClose={() => this.showDeleteModal("")}
                        style={this.state.customStyles}
                    >
                        <h3 className="modal-title">{t('Warning!')}</h3>
                    
                        <div className="mb-4">
                            <p>
                                {t('Deleting the Client Type will also delete other data related to it.')}       
                            </p>                     
                        </div>

                        <Row>
                            <Col sm={6}>
                                <Button variant="primary" onClick={() => this.showDeleteModal("")}>{t('Close')}</Button>
                            </Col>
                            <Col sm={6}>
                                <Button variant="danger" onClick={() => this.confirmDelete()}> {t('Delete')}</Button>
                            </Col>                
                        </Row>
                
                    </Modal>
                </>
    )
}
}
const mapStateToProps = state => {
    return {
        message: state.adminClient.message,        
        credentials: state.user.credentials,
        searchClientType: state.codeBook.searchClientType,
        clientTypeList: state.codeBook.clientTypeList       
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
   
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TipoviKlijenata));


